import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

const AddModal = ({
    show,
    onHide,
    selectedProject,
    setSelectedProject,
    selectedTaskList,
    setSelectedTaskList,
    selectedWorkflow,
    setSelectedWorkflow,
    selectedAssignees,
    setSelectedAssignees,
    projectOptions,
    workflowOptions,
    assigneeOptions
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered  size="lg">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Add Tasklist</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className='gy-3'>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Select a Project <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedProject}
                                        onChange={setSelectedProject}
                                        options={projectOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Tasklist Name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={selectedTaskList}
                                        onChange={(e) => setSelectedTaskList(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Associate Workflow <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedWorkflow}
                                        onChange={setSelectedWorkflow}
                                        options={workflowOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Assignees <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedAssignees}
                                        onChange={setSelectedAssignees}
                                        options={assigneeOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <div>
                    <Button variant="primary" className='me-3' onClick={onHide}>
                        Create & Another
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Add Tasklist
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default AddModal;
